export const fileToBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const [meta, base64] = reader.result.split(",");
      const mimeMatch = meta.match(/^data:([^;]+);base64,/);
      const ext = mimeMatch ? mimeMatch[1].split("/")[1] : file.name.split(".").pop();
      resolve(`${base64}#${ext}`);
    };
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
  });